import request from "@/utils/request";

//标签列表
export function getTagList() {
  return request({
    url: "/tags",
    headers: {
      isToken: false
    },
    method: "get"
  });
}
